




































import { defineComponent, PropType, ref, useFetch } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStore } from '~/composables/useStore';
import { NEWS_TYPE } from '~/constants/contents';
import { url } from '~/utils';
import { sendGaEvent as sendEvent, GaTopPartsType } from '~/utils/ga';
import { ECSchema } from '~/types/api';
import { NewsCard } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppLink,
  },
  props: {
    news: {
      type: Object as PropType<NewsCard>,
      required: true,
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    informationShopNames: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
  },
  setup(props) {
    const store = useStore();
    const shopNames = ref<Array<string>>([]);

    /** 拠点詳細API経由で記事に関連する店舗名を取得 */
    useFetch(async (): Promise<void> => {
      if (props.informationShopNames.length > 0) {
        shopNames.value = props.informationShopNames;
        return;
      }
      // 店舗名が存在していれば店舗名配列に格納
      if (props.news.display_destination.length === 0) {
        shopNames.value = [];
      } else {
        const ids = props.news.display_destination.slice(0, 5);
        const { data } = await store.dispatch('modules/salesLocation/fetchAllSalesLocations', {
          query: {
            ids: ids.join(','),
            limit: 5,
            page: 1,
          },
        });

        shopNames.value =
          data
            ?.map((shopDetail: ECSchema<'saleslocation.SalesLocation'>) => {
              if (shopDetail.place_local_name) {
                return shopDetail.place_local_name;
              } else {
                return '';
              }
            })
            .filter(Boolean) || [];
      }
    });

    /** 日付をYYYY.MM.DDにフォーマット */
    const formatDate = (date: string) => dayjs(date).tz('Asia/Tokyo').format('YYYY.MM.DD');

    const sendGaEvent = () => {
      if (!props.gaPartsType) {
        return;
      }
      sendEvent(props.gaPartsType, url('NEWS_DETAIL', { permalink: props.news.link }), props.news.title);
    };

    return { shopNames, formatDate, url, sendGaEvent, NEWS_TYPE };
  },
});
